// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Semigroup from "../Data.Semigroup/index.js";
import * as Data_String_Common from "../Data.String.Common/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Foreign_Generic_Class from "../Foreign.Generic.Class/index.js";
import * as Partial_Unsafe from "../Partial.Unsafe/index.js";
import * as Restaumatic_Form_Internal from "../Restaumatic.Form.Internal/index.js";
import * as Specular_FRP_Base from "../Specular.FRP.Base/index.js";
import * as Specular_FRP_Host from "../Specular.FRP.Host/index.js";
import * as Type_AnnEquality from "../Type.AnnEquality/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Host.applicativeHost);
var pure1 = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var readDynamic = /* #__PURE__ */ Specular_FRP_Base.readDynamic(Effect_Class.monadEffectEffect);
var pure2 = /* #__PURE__ */ Control_Applicative.pure(Specular_FRP_Base.applicativeDynamic);
var encode = /* #__PURE__ */ Foreign_Generic_Class.encode(/* #__PURE__ */ Foreign_Generic_Class.recordEncode()(Foreign_Generic_Class.encodeRecordNil));
var append = /* #__PURE__ */ Data_Semigroup.append(Data_Semigroup.semigroupArray);
var Action = function (x) {
    return x;
};
var isActionFunctionEffectUni = {
    triggerImpl: function (f) {
        return f;
    }
};
var isActionEffectUnit = {
    triggerImpl: function (f) {
        return function (v) {
            return f;
        };
    }
};
var isActionAction = {
    triggerImpl: function (v) {
        return function (param) {
            return v.effect(param);
        };
    }
};
var initializeNoInitializerAc = function () {
    return {
        makeImpl: function (v) {
            return Partial_Unsafe.unsafeCrashWith("undefined");
        }
    };
};
var initializeNoInitialValueA = function (dictAnnTypeEquals) {
    var to = Type_AnnEquality.to(dictAnnTypeEquals);
    return {
        makeImpl: function (p) {
            return function (opts) {
                return function (v) {
                    return function (initializer) {
                        return pure({
                            effect: to(p)(initializer),
                            name: opts.name
                        });
                    };
                };
            };
        }
    };
};
var initializeNoInitialValueA1 = function (dictAnnTypeEquals) {
    var to = Type_AnnEquality.to(dictAnnTypeEquals);
    return {
        makeImpl: function (p) {
            return function (opts) {
                return function (v) {
                    return function (initializer) {
                        return pure({
                            effect: function (v1) {
                                return to(p)(initializer);
                            },
                            name: opts.name
                        });
                    };
                };
            };
        }
    };
};
var hasFieldIdAction = {
    getFieldId: function (v) {
        return Restaumatic_Form_Internal.fieldPathToString(v.name);
    }
};
var addErrorsAction = {
    addErrors: function (v) {
        return function (v1) {
            return pure1(Data_Unit.unit);
        };
    }
};
var triggerImpl = function (dict) {
    return dict.triggerImpl;
};
var isActionDelayed = function (dictIsAction) {
    var triggerImpl1 = triggerImpl(dictIsAction);
    return {
        triggerImpl: function (v) {
            return function (params) {
                return function __do() {
                    var action = readDynamic(v)();
                    return triggerImpl1(action)(params)();
                };
            };
        }
    };
};
var isActionWithId = function (dictIsAction) {
    var triggerImpl1 = triggerImpl(dictIsAction);
    return {
        triggerImpl: function (v) {
            return triggerImpl1(v.value0.field);
        }
    };
};
var trigger = function (dictIsAction) {
    return triggerImpl(dictIsAction);
};
var trigger1 = /* #__PURE__ */ trigger(isActionAction);
var triggerCb = function () {
    return function (a) {
        return trigger1(a);
    };
};
var trigger_ = function (dictIsAction) {
    var trigger2 = trigger(dictIsAction);
    return function (a) {
        return trigger2(a)(Data_Unit.unit);
    };
};
var dumpStateAction = {
    dumpState: function (v) {
        return pure2(encode({}));
    }
};
var apply = function (dictHasFieldId) {
    var getFieldId = Restaumatic_Form_Internal.getFieldId(dictHasFieldId);
    return function (v) {
        return function (param) {
            return pure1({
                effect: function (v1) {
                    return v.effect(param);
                },
                name: append(v.name)(Data_String_Common.split(".")(getFieldId(param)))
            });
        };
    };
};
var addContextAction = {
    addContext: function (v) {
        return function (v1) {
            return pure1(Data_Unit.unit);
        };
    }
};
export {
    triggerImpl,
    Action,
    trigger,
    trigger_,
    triggerCb,
    apply,
    initializeNoInitializerAc,
    initializeNoInitialValueA1,
    initializeNoInitialValueA,
    addContextAction,
    dumpStateAction,
    hasFieldIdAction,
    addErrorsAction,
    isActionAction,
    isActionFunctionEffectUni,
    isActionEffectUnit,
    isActionWithId,
    isActionDelayed
};
